import useLanguage from "../../i18n/useLanguage";

export default function AiVideoExample({ example }) {
  const { t } = useLanguage();
  return (
    <figure className="rounded-2xl border border-white/10 bg-neutral-950 overflow-hidden">
      <div className="bg-black p-4 sm:p-6">
        <video controls playsInline preload="none" poster={example.poster} aria-label={t(example.title)} className="mx-auto aspect-[9/16] w-full max-w-[260px] rounded-xl bg-black object-contain">
          <source src={example.src} type="video/mp4" />
          {t("Browser ini belum mendukung pemutaran video.")}
          <a href={example.src}>{t("Buka video")}</a>
        </video>
      </div>
      <figcaption className="p-6 border-t border-white/10">
        <h3 className="text-xl font-bold text-amber-300 mb-2">{t(example.title)}</h3>
        <p className="text-gray-400 leading-relaxed">{t(example.description)}</p>
      </figcaption>
    </figure>
  );
}
